import React from "react";
import { ZButton, ZTypography } from "@atoms";
import { EFooterVariant, IZImportFooterProps } from "./interface";

const ZImportFooter: React.FC<IZImportFooterProps> = ({
	variant,
	buttonText,
	onClick,
	disabled = false,
	isLoading = false,
	showAiDisclaimer = true,
	iconName,
	iconProps,
	className,
	onBack,
	backButtonText = "Back",
	backButtonDisabled = false
}) => {
	const renderButton = () => {
		if (variant === EFooterVariant.IMPORT_ZBUTTON) {
			return (
				<ZButton
					onClick={onClick}
					disabled={disabled}
					className={className || "z-import-button"}
					iconName={!isLoading ? iconName : undefined}
					iconPlacement="left"
					iconProps={iconProps}
				>
					{buttonText}
				</ZButton>
			);
		}

		return null;
	};

	return (
		<div className="py-4 bg-white border-t border-gray-3 flex-shrink-0 relative">
			<div className="flex flex-col items-center justify-center gap-2">
				<div className="flex items-center justify-center relative w-full gap-3">
					<div className="absolute -left-4 w-34 h-0.5 bg-gray-4"></div>
					{onBack && (
						<ZButton
							onClick={onBack}
							disabled={backButtonDisabled}
							className="border border-gray-5 cursor-pointer rounded-md text-sm hover:bg-gray-50 h-8 px-4"
						>
							{backButtonText}
						</ZButton>
					)}
					{renderButton()}
					<div className="absolute -right-4 w-34 h-0.5 bg-gray-4"></div>
				</div>
				{showAiDisclaimer && (
					<ZTypography.ZText colorVariant={7} className="text-center">
						AI can make mistakes. Please double check the response.
					</ZTypography.ZText>
				)}
			</div>
		</div>
	);
};

export default ZImportFooter;
